import axios from "axios";

export const getLaporanLabaRugi = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/laporanJurnal/labaRugi`,
    formData,
    { withCredentials: true }
  );
};
